import type { Rule } from "../types";
import { makeFiring } from "../util";

const EVIDENCE = "plews_2013_hrv_guided_training";

/**
 * Any subjective check-in in the last 48 hours flagged illness symptoms.
 * Plews 2013 is the closest seeded paper for "back off when systemic stress
 * is up" — illness counts. Dedicated illness papers can be added later.
 */
export const illnessSymptomsRecent: Rule = {
  id: "illness_symptoms_recent",
  domain: "health.recovery",
  topics: ["illness", "training_load"],
  evidence_refs: [EVIDENCE],
  title: () => "Illness symptoms logged",
  evaluate(ctx) {
    const now = ctx.now.getTime();
    const recent = ctx.subjective.filter(
      (c) =>
        c.illness_symptoms.length > 0 &&
        now - new Date(c.ts).getTime() <= 2 * 86_400_000,
    );
    if (recent.length === 0) return null;
    const symptomSet = new Set<string>();
    recent.forEach((c) => c.illness_symptoms.forEach((s) => symptomSet.add(s)));
    const symptoms = [...symptomSet].slice(0, 3).join(", ");
    return makeFiring({
      rule_id: "illness_symptoms_recent",
      now: ctx.now,
      tz: ctx.tz,
      severity: "bad",
      message: `Symptoms logged in last 48h: ${symptoms}. Treat as a no-training day until 24h symptom-free.`,
      evidence_refs: [EVIDENCE],
      factors: [
        {
          name: "symptom_count",
          value: symptomSet.size,
          contribution: "rest day",
          evidence_ref: EVIDENCE,
        },
      ],
      target_surface: "health.recovery",
      target_action: { kind: "rest_day" },
    });
  },
};
